/**
 * Language Preference Module
 *
 * Handles language site preferences and redirects to preferred language sites
 */

export const initLangPreference = () => {
    // Process langSite parameter if present
    const url = new URL(window.location.href);
    const langSiteParam = 'langSite';
    const langSite = url.searchParams.get(langSiteParam);
    if (langSite != null) {
        const langCookieValue = escape(`/${langSite}.html`);
        const expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + (365 * 1000 * 60 * 60 * 24));
        const expiryValue = langSite === '' ? 'Thu, 01 Jan 1970 00:00:00 UTC' : expiryDate.toUTCString();
        document.cookie = `langSite=${langCookieValue};expires=${expiryValue};path=/;secure;domain=.rockwellautomation.com;SameSite=strict`;
        url.searchParams.delete(langSiteParam);
        window.history.replaceState({}, '', url);
    }

    // Determine if we should check for redirects
    const thisPage = encodeURI(window.location.href);
    const isAem = /adobecqms\.net|localhost/.test(thisPage); // Do not redirect within AEM author/preview/local
    const isBot = /akamai|archive|bot|Chrome-Lighthouse|crawl|demandbase|facebook|insights|ping|PTST|siteimprove|speed|spider|yahoo|bingbot|googlebot|externalhit|dataforseo|turnitin|magus bot|yandexbot|meta-externalagent|PostmanRuntime|tencent|nayatel|dotbot|petalbot|googleother|bytespider|wechat|applebot|chromeframe/i.test(navigator.userAgent);
    const isPar = /utm_source|redir/.test(thisPage); // Do not redirect for URLs with Tracking code, or manual param (e.g. 'redir=no')

    // Check for preferred language site and redirect if necessary
    if (navigator.cookieEnabled && !(isAem || isBot || isPar)) {
        let siteCookie = document.cookie.match('(^|[^;]+)\\s*langSite\\s*=\\s*([^;]+)');
        siteCookie = siteCookie ? siteCookie.pop() : '';
        if (siteCookie !== '') {
            const currentSite = document.documentElement.hasAttribute('lang') ? document.documentElement.getAttribute('lang').toLowerCase() : '';
            const preferredSite = siteCookie.replace(/^\/(.+)\.html$/, '$1');
            if (currentSite !== '' && currentSite !== preferredSite) { // If this page is NOT on preferred site
                let newPage = '';
                const linkItems = document.getElementsByTagName('link');
                for (let i = 0; i < linkItems.length; i += 1) {
                    if (linkItems.item(i).hreflang === preferredSite) {
                        newPage = linkItems.item(i).href;
                        if (window.location.search) {
                            newPage = newPage + window.location.search;
                        }
                        break;
                    }
                }
                if (newPage !== '') window.location.href = newPage;
            }
        }
    }
};
